import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "message-list flex flex-col h-full" }
const _hoisted_2 = {
  key: 0,
  class: "text-center text-gray-400"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center text-gray-400 px-4"
}
const _hoisted_4 = { class: "p-2 sm:p-4 bg-gray-700 border-t border-gray-600 flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chat_header = _resolveComponent("chat-header")!
  const _component_message_item = _resolveComponent("message-item")!
  const _component_message_input = _resolveComponent("message-input")!
  const _component_rating_modal = _resolveComponent("rating-modal")!
  const _component_block_modal = _resolveComponent("block-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_chat_header, {
      otherUser: _ctx.otherUser,
      product: _ctx.product,
      showBackButton: _ctx.showBackButton,
      onBack: _ctx.goBack,
      onOpenRatingModal: _ctx.openRatingModal,
      onOpenBlockModal: _ctx.openBlockModal
    }, null, 8, ["otherUser", "product", "showBackButton", "onBack", "onOpenRatingModal", "onOpenBlockModal"]),
    _createElementVNode("div", {
      ref: "messagesContainer",
      class: _normalizeClass(["flex-grow overflow-y-auto p-2 sm:p-4 space-y-3 sm:space-y-4", {
        'flex items-center justify-center': _ctx.showLoader || !_ctx.hasMessages,
      }])
    }, [
      (_ctx.showLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "flex items-center justify-center" }, [
              _createElementVNode("svg", {
                class: "animate-spin h-5 w-5 mr-2",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }),
                _createElementVNode("path", {
                  class: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                })
              ]),
              _createTextVNode(" Učitavanje... ")
            ], -1)
          ])))
        : (!_ctx.hasMessages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
              _createElementVNode("p", null, "Nema poruka. Započnite razgovor.", -1)
            ])))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.messages, (message) => {
              return (_openBlock(), _createBlock(_component_message_item, {
                key: message.id,
                message: message,
                isCurrentUser: _ctx.isCurrentUser(message)
              }, null, 8, ["message", "isCurrentUser"]))
            }), 128))
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_message_input, {
        onSend: _ctx.sendMessage,
        onError: _ctx.handleError
      }, null, 8, ["onSend", "onError"])
    ]),
    (_ctx.ratingModal.show)
      ? (_openBlock(), _createBlock(_component_rating_modal, {
          key: 0,
          otherUser: _ctx.otherUser,
          ratingModal: _ctx.ratingModal,
          onClose: _ctx.closeRatingModal,
          onSetRatingLike: _ctx.setRatingLike,
          onSubmit: _ctx.submitRating
        }, null, 8, ["otherUser", "ratingModal", "onClose", "onSetRatingLike", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.blockModal.show)
      ? (_openBlock(), _createBlock(_component_block_modal, {
          key: 1,
          otherUser: _ctx.otherUser,
          onClose: _ctx.closeBlockModal,
          onConfirm: _ctx.confirmBlock
        }, null, 8, ["otherUser", "onClose", "onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}